import React from "react";
import { BoxOptionsType, CTAModuleType } from "../CTA";
import { MediaItemResponsive } from "@/components/MediaItem/MediaItemResponsive";
import styles from "../CTA.module.scss";
import { MediaFormatType } from "@/types/ModuleOptionsType";

function CTAMedia({
  data,
  sizes,
  mediaFormat,
  box,
}: {
  data: CTAModuleType;
  sizes: string;
  mediaFormat: MediaFormatType;
  box: BoxOptionsType;
}) {
  const { media } = data.cta;
  const { image_desktop, image_tablet, image_mobile, image_fullhd } = media;
  const { show_card_box, show_box_shadow, show_border_radius } = box;
  return (
    <div className={`${styles["cta-media"]}`}>
      <MediaItemResponsive
        image_fullhd={image_fullhd}
        image_desktop={image_desktop}
        image_tablet={image_tablet}
        image_mobile={image_mobile}
        sizes={sizes}
        mediaFormat={mediaFormat}
        className={`${show_card_box && show_box_shadow ? "has-box-shadow" : ""} ${show_card_box && show_border_radius ? "has-border-radius" : ""}`}
      />
    </div>
  );
}

export default CTAMedia;
